
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VisceralTractionReaction',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/VisceralTractionReaction.vue